<template>
  <div class="visual-element-mux">
    <FormVisualElement class="col-1/2" @valid="$emit('valid', $event)">
      <FormRow
        class="w-1/2 mb-10"
        label="Formato"
        :forId="`visual-element-format-${_id}`"
        name="format"
        rules="required"
      >
        <v-select
          v-model="modelDataElement.format"
          :options="formatOptions"
          :searchable="false"
          :clearable="false"
          :reduce="type => type.value"
        />
      </FormRow>

      <MuxUpload
        v-model="modelDataElement.src"
        :input-id="`visual-element-mux-file-${_id}`"
      />
    </FormVisualElement>
  </div>
</template>

<script>
/** Components */
import VisualElementBase from '@/components/VisualElementBase.vue'
import MuxUpload from '@/components/MuxUpload.vue'

export default {
  extends: VisualElementBase,

  components: {
    MuxUpload,
  },

  defaultContent: {
    src: '',
    format: 'fullscreen',
  },

  data() {
    return {
      formatOptions: [
        { label: 'Fullscreen', value: 'fullscreen' },
        { label: 'Quadrato', value: 'square' },
        { label: '16:9', value: 'vertical' },
      ],
    }
  },
}
</script>
